import React, { useContext, useEffect } from 'react'

import { AppStateContext } from '../../state/AppProvider'
import CloseIcon from '../../icons/CloseIcon'

import styles from './ChatWidgetLauncher.module.css'

type ChatWidgetLauncherProps = {
  logo: string
}

const ChatWidgetLauncher = ({ logo }: ChatWidgetLauncherProps) => {
  const appStateContext = useContext(AppStateContext)
  const ui = appStateContext?.state.frontendSettings?.ui
  const isChatWidgetOpen = appStateContext?.state.isChatWidgetOpen

  useEffect(() => {
    window.addEventListener('message', e => {
      if (e.data?.action === 'open_widget_from_outside') toggleChatWidget()
      if (e.data?.action === 'toggle_fullscreen') {
        appStateContext?.dispatch({ type: 'TOGGLE_FULLSCREEN_CHAT', payload: !isChatWidgetOpen })
      }
    })
  }, [])

  const toggleChatWidget = () => {
    appStateContext?.dispatch({ type: 'TOGGLE_CHAT_WIDGET' })
    parent.postMessage({ action: 'toggle_chat' }, '*')
  }

  return (
    <button
      className={styles.aiChatWidgetChatWidgetLauncher}
      onClick={() => toggleChatWidget()}
      style={{
        background: ui?.gradient_color
      }}>
      {isChatWidgetOpen ? (
        <span className={styles.aiChatWidgetChatWidgetLauncherCloseIcon}>
          <CloseIcon width={30} height={30} />
        </span>
      ) : (
        <img src={logo} aria-hidden="true" alt="Chat logo" className={styles.aiChatWidgetChatWidgetLauncherLogo} />
      )}
    </button>
  )
}

export default ChatWidgetLauncher
